import { render, staticRenderFns } from "./PatientTasks.vue?vue&type=template&id=ccd3b71c&lang=pug"
import script from "./PatientTasks.vue?vue&type=script&lang=js"
export * from "./PatientTasks.vue?vue&type=script&lang=js"
import style0 from "./PatientTasks.vue?vue&type=style&index=0&id=ccd3b71c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports